export const arrowUp = [
  '24 24',
  `<polygon points="12,6.586 3.293,15.293 4.707,16.707 12,9.414 19.293,16.707 20.707,15.293 12,6.586"/>`
]
